var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination"},[_c('paginate',{attrs:{"page-count":_vm.pagination.pageCount,"prev-text":'<',"next-text":'>',"first-last-button":false,"active-class":'current',"click-handler":_vm.fetch},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }